<div class="flex flex-row justify-start items-center company-name flex-[33%] max-w-[33%]">
  <p>{{ userDetailsStore.companyName$ | async }}</p>
</div>
<div class="flex flex-row justify-start items-center address flex-[28%] max-w-[28%]">
  <p>
    {{ userDetailsStore.companyAddressForFlatRate$ | async }}
  </p>
</div>
<div class="details flex flex-row justify-start items-center flex-[33%] max-w-[33%]">
  <div class="flex flex-row">
    <vi-item
      data-at-user-type-details
      size="medium"
      title="{{ '+USER_DETAILS.BOOKINGS.BOOKING_DATE' | translate }}"
      [value]="subscription.subscriptionDate | date"
    ></vi-item>
    <vi-item
      data-at-user-type-details
      size="medium"
      [title]="title | translate"
      [value]="subscription.expirationDate | date"
    ></vi-item>
    <vi-item
      *ngIf="subscription.status?.toLowerCase() === subscriptionsStatusType.canceled"
      data-at-user-type-details
      size="medium"
      title="{{ '+BOOKING.OVERVIEW.SUBSCRIPTION.DURATION' | translate }}"
      [value]="leftDays"
    ></vi-item>
    <vi-item
      data-at-user-type-details
      size="medium"
      title="{{ '+BOOKING.OVERVIEW.SUBSCRIPTION.BOOKING_FROM' | translate }}"
      [value]="subscription.subscribedByName"
    ></vi-item>
  </div>
</div>
<div class="menu flex flex-row justify-start items-center flex-[6%] max-w-[6%]">
  <ng-container *ngIf="isCancelMenuVisible">
    <button mat-button [matMenuTriggerFor]="menu">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <button
        mat-menu-item
        appCancelBooking
        [companyId]="companyId"
        [isFlatRate]="true"
        [subscriptionPlan]="subscription.plan"
        gtm="onOpen"
        gtmAction="Cancel booking"
        gtmCategory="userDetails"
      >
        {{ '+USER_DETAILS.BOOKINGS.CANCEL_BOOKING_MODAL.BUTTON.CANCEL_BOOKING' | translate }}
      </button>
    </mat-menu>
  </ng-container>
</div>
